const $826ac31e67f2a682$var$ref = [
    "u",
    "d",
    "u",
    "d",
    "l",
    "r",
    "l",
    "r",
    "b",
    "a"
];
let $826ac31e67f2a682$var$seq = [];
const $826ac31e67f2a682$var$check = ()=>{
    if ($826ac31e67f2a682$var$seq.length !== $826ac31e67f2a682$var$ref.length) return false;
    for(let i = 0; i < $826ac31e67f2a682$var$seq.length; i++){
        if ($826ac31e67f2a682$var$seq[i] !== $826ac31e67f2a682$var$ref[i]) return false;
    }
    return true;
};
const $826ac31e67f2a682$var$load = ()=>{
    window.open("https://jonoaugustine.gitlab.io/web-snake-game/", "_blank");
};
window.addEventListener("keydown", (e)=>{
    switch(e.key){
        case "ArrowUp":
            $826ac31e67f2a682$var$seq.push("u");
            break;
        case "ArrowDown":
            $826ac31e67f2a682$var$seq.push("d");
            break;
        case "ArrowRight":
            $826ac31e67f2a682$var$seq.push("r");
            break;
        case "ArrowLeft":
            $826ac31e67f2a682$var$seq.push("l");
            break;
        case "a":
            $826ac31e67f2a682$var$seq.push("a");
            break;
        case "b":
            $826ac31e67f2a682$var$seq.push("b");
            break;
        case "r":
            $826ac31e67f2a682$var$seq = [];
            return;
    }
    if ($826ac31e67f2a682$var$check()) $826ac31e67f2a682$var$load();
});


var $1eebc064a5664a07$exports = {};
$1eebc064a5664a07$exports = import.meta.resolve("bTpOS");


var $b1a36bd157ee16af$exports = {};
$b1a36bd157ee16af$exports = import.meta.resolve("hhFYf");


var $14add4f082c89641$exports = {};
$14add4f082c89641$exports = import.meta.resolve("aq6me");


var $9eeaefb440d3a1cb$exports = {};
$9eeaefb440d3a1cb$exports = import.meta.resolve("23oCs");


var $655bd8df401c259f$exports = {};
$655bd8df401c259f$exports = import.meta.resolve("9h3pG");


var $69b848be85867a79$exports = {};
$69b848be85867a79$exports = import.meta.resolve("1MDhF");


var $196ba6f56c0c8b8b$exports = {};
$196ba6f56c0c8b8b$exports = import.meta.resolve("cummJ");


var $928554b0753b47ba$exports = {};
$928554b0753b47ba$exports = import.meta.resolve("j07wg");


const $c0a4806dcf866926$var$projects = [
    {
        name: "Boil",
        source: "https://gitlab.com/boiljs/boil-cli",
        description: "Configurable, Sync-able, and Sharable boilerplate NodeJS project generator. Designed to reduce project creation hassle with a semantic CLI. Includes file-structure and package.json bootstrapping.",
        imageSrc: new URL($1eebc064a5664a07$exports),
        invert: false,
        tools: [
            "NodeJS",
            "FaunaDB",
            "RollupJS",
            "Mocha",
            "Gitlab CI/CD",
            "Semantic Versioning",
            "Yarn"
        ]
    },
    {
        name: "Paypal Invoice API",
        live: "https://www.npmjs.com/package/paypal-invoices",
        source: "https://gitlab.com/JonoAugustine/paypal-invoices",
        description: "A JS api wrapper for paypal 2.0 invoices which was lacking from official Paypal SDKs. The project works towards 100% API coverage.",
        tools: [
            "NodeJS",
            "Paypal API",
            "RollupJS",
            "Semantic Release"
        ]
    },
    {
        name: "Vulpa the Youtube Chat Bot",
        live: "https://youtube.com/playlist?list=PLcHj3H-ImhdYOgOy5cxfKSUnOO_65E5Qx",
        source: "https://github.com/pinkilo/Vulpa",
        description: "A Youtube-live chatbot made from scratch using typescript, websockets, and canvas animation",
        imageSrc: new URL($b1a36bd157ee16af$exports),
        invert: false,
        tools: [
            "Typescript",
            "RollupJS",
            "BabelJS",
            "Websockets",
            "canvas animation"
        ]
    },
    {
        name: "Strife",
        source: "https://gitlab.com/serebit/strife",
        description: "An idiomatic Kotlin implementation of the Discord API for use with custom bots.",
        imageSrc: new URL($14add4f082c89641$exports),
        invert: false,
        tools: [
            "Discord API",
            "KTor",
            "Gitlab CI/CD"
        ]
    },
    {
        name: "Evolution Emulator",
        source: "https://github.com/JonoAugustine/Evolution-Emulator",
        description: "A basic attempt at emulating Earthen evolution with OOP.",
        imageSrc: new URL($9eeaefb440d3a1cb$exports),
        invert: true
    },
    {
        name: "ScoreBorda",
        live: "https://score-borda.vercel.app",
        source: "https://github.com/JonoAugustine/ScoreBorda",
        description: "The ultimate decision making tool for the troubled mind",
        imageSrc: new URL($655bd8df401c259f$exports),
        invert: false
    },
    {
        name: "Aquatic Mastery",
        live: "https://youtube.com/aquaticmaster",
        description: "A YouTube channel centered around sharing my experiences as an aquarist and showing others how to achieve success in their own aquariums.",
        imageSrc: new URL($69b848be85867a79$exports)
    },
    {
        name: "YukiBot",
        source: "https://github.com/pinkilo/yukibot",
        description: "A easy-to-use typescript library for building YouTube Live broadcast chatbots.",
        invert: false,
        tools: [
            "NodeJS",
            "FaunaDB",
            "RollupJS",
            "Mocha",
            "Gitlab CI/CD",
            "Semantic Versioning",
            "Yarn"
        ]
    },
    {
        name: "Snek",
        live: "https://jonoaugustine.gitlab.io/web-snake-game/",
        source: "https://gitlab.com/JonoAugustine/web-snake-game",
        description: "Browser-based Snake Game aimed at giving full controll over game settings to the player.",
        imageSrc: new URL($196ba6f56c0c8b8b$exports),
        invert: false,
        tools: [
            "NodeJS",
            "ParcelJS",
            "SASS",
            "Gitlab CI/CD"
        ]
    },
    {
        name: "Augustine Education Services",
        live: "https://augustine.education",
        description: "Augustine Educational Services advises, educates, and counsels students and families regarding educational choices. This project provides a landing page for AES with a modern design.",
        tools: [
            "ParcelJS",
            "SCSS",
            "Gitlab CI/CD"
        ]
    },
    {
        name: "Age of Revisionism",
        live: "https://ageofrevisionism.com/",
        source: "https://gitlab.com/JonoAugustine/age-of-revisionism",
        description: "A web-app which generates modification files for Age of Empires 2: Definitive Edition.",
        imageSrc: new URL($928554b0753b47ba$exports),
        invert: false,
        tools: [
            "Svelte",
            "RollupJS",
            "Gitlab CI/CD",
            "Typescript"
        ]
    },
    {
        name: "Firebase Rules Generator",
        live: "https://www.npmjs.com/package/frug",
        source: "https://gitlab.com/JonoAugustine/frug",
        description: "A CLI tool which converts readable DB schemas into Firebase Firestore Rules.",
        tools: [
            "Typescript",
            "Firebase Rules",
            "Semantic-Release",
            "Gitlab CI/CD",
            "Mocha/Chai",
            "eslint"
        ]
    },
    {
        name: "This Portfolio",
        live: "https://jonoaugustine.com",
        source: "https://gitlab.com/JonoAugustine/portfolio",
        description: "This very portfolio",
        tools: [
            "Typescript",
            "ParcelJS",
            "SCSS",
            "Gitlab CI/CD"
        ]
    }
];
var $c0a4806dcf866926$export$2e2bcd8739ae039 = $c0a4806dcf866926$var$projects;


const $504c2f61098a857b$export$4385e60b38654f68 = (arr)=>arr[Math.floor(Math.random() * arr.length)];


document.getElementById("header_scroll").addEventListener("click", ()=>document.querySelector("nav").scrollIntoView());
/**
 * Creates a new element of the given tag.
 * @param {string} tag Element tag
 * @returns {HTMLElement}
 */ const $328eaaa238fe5329$var$E = (tag)=>document.createElement(tag);
/**
 * Creates a new Heading element of the given size with the given text.
 * @param {number} size
 * @param {string} text
 */ const $328eaaa238fe5329$var$H = (size, text)=>{
    const e = $328eaaa238fe5329$var$E(`h${size}`);
    e.innerText = text;
    return e;
};
/**
 *
 * @param {string} link
 * @param  {...any} children
 */ const $328eaaa238fe5329$var$A = (link)=>{
    const a = $328eaaa238fe5329$var$E("a");
    a.setAttribute("href", link);
    a.setAttribute("target", "_blank");
    return a;
};
const $328eaaa238fe5329$var$Button = (link, text)=>{
    const e = $328eaaa238fe5329$var$E("button");
    e.innerText = text;
    e.addEventListener("click", ()=>window.open(link, "_blank"));
    return e;
};
/**
 *
 * @param {string} src
 * @param {string} alt
 */ const $328eaaa238fe5329$var$Img = (src, alt)=>{
    const i = $328eaaa238fe5329$var$E("img");
    i.setAttribute("src", src);
    i.setAttribute("alt", alt);
    i.setAttribute("loading", "lazy");
    i.setAttribute("decoding", "async");
    return i;
};
const $328eaaa238fe5329$export$2b77a92f1a5ad772 = (parent, autoClose, showTimeout)=>{
    const modal = $328eaaa238fe5329$var$E("div");
    modal.classList.add("modal", "center", "closed");
    const icon = $328eaaa238fe5329$var$E("i");
    icon.classList.add("fas", "fa-times", "exit");
    icon.addEventListener("click", ()=>{
        modal.classList.add("closed");
        setTimeout(()=>modal.remove(), showTimeout);
    });
    modal.appendChild(icon);
    parent.appendChild(modal);
    setTimeout(()=>{
        modal.classList.remove("closed");
        if (autoClose) {
            let inter = setInterval(()=>{
                if (modal.classList.contains("closed")) {
                    modal.remove();
                    clearInterval(inter);
                } else modal.classList.add("closed");
            }, 5000);
        }
    }, showTimeout ? showTimeout : 100);
    return modal;
};
const $328eaaa238fe5329$export$bacf8f04493bf68c = (project)=>{
    const base = $328eaaa238fe5329$var$E("div");
    base.className = `card animated slideIn${(0, $504c2f61098a857b$export$4385e60b38654f68)([
        "Left",
        "Right",
        "Up"
    ])}`;
    let thumbnail;
    if (project.imageSrc) {
        thumbnail = $328eaaa238fe5329$var$Img(project.imageSrc, project.name);
        thumbnail.classList.add("thumbnail");
        if (project.invert) thumbnail.classList.add("invert");
    } else {
        thumbnail = $328eaaa238fe5329$var$H(1, project.name[0]);
        thumbnail.classList.add("placeholder");
    }
    base.appendChild(thumbnail);
    // Details
    const container = $328eaaa238fe5329$var$E("div");
    container.classList.add("content", "container");
    base.append(container);
    container.appendChild($328eaaa238fe5329$var$H(1, project.name));
    const view = $328eaaa238fe5329$var$E("div");
    view.classList.add("row", "links");
    container.append(view);
    if (project.live) view.appendChild($328eaaa238fe5329$var$Button(project.live, "View Live"));
    if (project.source) view.appendChild($328eaaa238fe5329$var$Button(project.source, "View Source"));
    if (!project.screenshotSrc) base.classList.add("no-info");
    // Description
    const description = $328eaaa238fe5329$var$E("p");
    description.innerText = project.description;
    container.appendChild(description);
    // Tools Used section\
    if (project.tools) {
        const tools = $328eaaa238fe5329$var$E("p");
        tools.innerText = `Tools: ${project.tools.reduce((sum, curr, i)=>{
            return sum + (i < project.tools.length ? ", " : "") + curr;
        })}`;
        tools.classList.add("tools");
        container.appendChild(tools);
    }
    // Extra details & screenshots
    const extra = $328eaaa238fe5329$var$E("div");
    extra.classList.add("extra");
    base.appendChild(extra);
    if (project.screenshotSrc) extra.appendChild($328eaaa238fe5329$var$Img(project.screenshotSrc, "screenshot"));
    base.addEventListener("click", ()=>{
        if (project.screenshotSrc) {
            if (!base.classList.contains("open")) {
                document.querySelectorAll(".card.open").forEach((e)=>{
                    e.classList.remove("open");
                });
                base.classList.add("open");
                base.scrollIntoView();
            } else base.classList.remove("open");
        }
    });
    return base;
};


// Load UI elements
const $ecb74c2a8f25c0d0$var$cards = document.getElementById("cards");
(0, $c0a4806dcf866926$export$2e2bcd8739ae039).map((p)=>(0, $328eaaa238fe5329$export$bacf8f04493bf68c)(p)).forEach((pc)=>$ecb74c2a8f25c0d0$var$cards.appendChild(pc));


//# sourceMappingURL=site.488f2d9b.js.map
